let scriptsLoaded = false;

function loadScripts(e) {
  if (scriptsLoaded || (e && !e.isTrusted)) return;
  scriptsLoaded = true;

  setTimeout(function () {
    if (document.body.dataset.template !== 'product') {
      loadScript("//frenchbeautyco.com.au/cdn/shop/t/206/assets/main.js?v=140936038414832229891791436191");
    }
    loadScript("//frenchbeautyco.com.au/cdn/shop/t/206/assets/gtag.js?v=123314133592264502631791436189");
    loadScript("//frenchbeautyco.com.au/cdn/shop/t/206/assets/tiny-img-link-preloader.js?v=118990956442820455871791436190");
    loadScript("//frenchbeautyco.com.au/cdn/shop/t/206/assets/lazyload.js?v=152529154860910744421791436190");
    // If needed, load CSS
    // loadCSS("//frenchbeautyco.com.au/cdn/shop/t/206/assets/salearrangecallback.css?v=70691");
  }, 10);

  document.removeEventListener('click', loadScripts);
  document.removeEventListener('mouseover', loadScripts);
  document.removeEventListener('scroll', loadScripts);
}

// Trigger immediately if scrollY >= 400
if (window.scrollY >= 400) {
  loadScripts();
} else {
  document.addEventListener('mouseover', loadScripts);
  document.addEventListener('click', loadScripts);
  document.addEventListener('scroll', loadScripts);
}

function loadScript(src) {
  var script = document.createElement('script');
  script.src = src;
  script.async = true;
  document.head.appendChild(script);
}

function loadScriptWithCallBack(src, callback) {
  var script = document.createElement('script');
  script.src = src;
  script.onload = callback || function () {};
  document.head.appendChild(script);
}

function loadCSS(href) {
  var link = document.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';
  link.type = 'text/css';
  document.head.appendChild(link);
}
